import { useEffect } from 'react'
import { useUIStore } from '@/stores/ui'

/**
 * Hook to track online/offline network status
 * Updates the UI store when connectivity changes
 */
export function useNetworkStatus(): boolean {
  const { isOnline, setOnline } = useUIStore()

  useEffect(() => {
    const handleOnline = () => setOnline(true)
    const handleOffline = () => setOnline(false)

    // Set initial state
    setOnline(navigator.onLine)

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [setOnline])

  return isOnline
}
